
import Icon from 'JS/components/Icon.vue';
import SavedVehicle from 'JS/components/automotive/SavedVehicle.vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { ICustomerVehicle } from 'JS/types/Automotive';

@Component({
	name: 'SavedVehicleCard',
	components: {
		Icon,
		SavedVehicle,
	}
})
export default class SavedVehicleCard extends Vue {

	/* Props
	============================================*/

	@Prop({ type: Boolean, required: false })
	readonly editable: boolean;

	@Prop({ type: Boolean, required: false })
	readonly selectable: boolean;

	@Prop({ type: Object, required: true })
	readonly vehicle: ICustomerVehicle;

}

